import React, { useEffect, useState } from "react";

import { getSoilAIContentRecommendations, getSoilAIRelatedContent, getSoilAISearchedContent } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminSection, AdminTable, Col, Collapse, Form, InputSearch, Link, MainPage, Panel, Row, TagNormal } from "components";

export const ContentRecommendations = () => {
  const [recommendations, setRecommendations] = useState(false);
  const [related, setRelated] = useState(false);
  const [searched, setSearched] = useState(false);
  const [timer, setTimer] = useState({});
  const signal = useCancelAsyncOnUnmount()();

  const openItem = (item) => {
    goTo(null, null, `${process.env.REACT_APP_FARM_URL}/${item.type}/${item.link}`, true);
  };

  const getRecommendations = () => {
    getSoilAIContentRecommendations({
      signal,
    }).then((res) => {
      setRecommendations(res);
    });
  };

  const getRelatedContent = () => {
    getSoilAIRelatedContent({
      signal,
    }).then((res) => {
      setRelated(res);
    });
  };

  const searchStuff = (s) => {
    getSoilAISearchedContent({
      s,
      signal,
    }).then((res) => {
      setSearched(res);
    });
  };

  const search = (s) => {
    setTimer(clearTimeout(timer));
    if (s.length >= 3) {
      setTimer(
        setTimeout(() => {
          searchStuff(s);
        }, 1000)
      );
    }
  };

  useEffect(() => {
    getRecommendations();
    getRelatedContent();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={false} pageName={"admin"}>
      <AdminHead
        headline={
          <>
            SoilAI content recommendations <TagNormal text="ALPHA" style={{ transform: "translate(0, -50%)", fontWeight: "bold" }} />
          </>
        }
        description={
          <>
            Content recommendations are automatically generated for users each night. The models take into account user behaviour, related users, and yearly
            crop entries. The models can also be used to find similar content or perform searches.
          </>
        }
      />
      {recommendations && (
        <>
          <AdminSection headline="User recommendations" />
          <Row>
            <Col>
              <Collapse mode="left">
                {recommendations.map((recommendation, i) => (
                  <Panel key={i} header={<h5>{recommendation.user.name || recommendation.user.email || recommendation.user.id}</h5>}>
                    <AdminTable
                      dataSource={recommendation.recommendations}
                      config={{
                        exclude: ["link"],
                        actions: [
                          {
                            icon: "tabler/eye",
                            func: openItem,
                            tooltip: "View this article",
                          },
                        ],
                      }}
                    />
                  </Panel>
                ))}
              </Collapse>
            </Col>
          </Row>
        </>
      )}

      {related && (
        <>
          <AdminSection headline="Related content" />
          <Row>
            <Col>
              <Collapse mode="left">
                {related.map((item, i) => (
                  <>
                    <Panel key={i} header={<h5>{item.article.title}</h5>}>
                      <Link onClick={() => openItem({ ...item.article, ...{ type: "article" } })}>View this article</Link>
                      <br />
                      <br />
                      <AdminTable
                        dataSource={item.related}
                        config={{
                          exclude: ["link"],
                          actions: [
                            {
                              icon: "tabler/eye",
                              func: openItem,
                              tooltip: "View this article",
                            },
                          ],
                        }}
                      />
                    </Panel>
                  </>
                ))}
              </Collapse>
            </Col>
          </Row>
        </>
      )}

      <AdminSection headline="Content search" />
      <Row gutter={[{ xs: 8, sm: 8, md: 16 }, 0]}>
        <Col>
          <Form name="searchForm">
            <InputSearch name="search" label="Search" onChange={(e) => search(e.target.value)} className="margin-0 margin-top-100 margin-bottom-100" />
          </Form>
        </Col>
      </Row>
      {searched && (
        <Row>
          <Col>
            <AdminTable
              dataSource={searched}
              config={{
                exclude: ["link"],
                actions: [
                  {
                    icon: "tabler/eye",
                    func: openItem,
                    tooltip: "View this article",
                  },
                ],
              }}
            />
          </Col>
        </Row>
      )}
    </MainPage>
  );
};
